import { Grid } from '@mui/material';
import { ReactNode } from 'react';

export const ChartCardContainer = ({ children }: { children: ReactNode }) => {
  return <Grid size={{ lg: 6, xs: 12 }}>{children}</Grid>;
};
